import { CmsDetailVendor } from '../../../components/Cms';

export function Cms() {
  return <CmsDetailVendor />;
}
